<template>
  <div>
    <div v-if="!isLastChallenge">
      <div class="challenge-card rounded box-shadow-primary bg-white flex">
        <div
          class="card-side flex items-center justify-center"
          :style="{ backgroundColor: sideCardBackgroundColor }"
        >
          <img :src="sideCardIconUrl" alt="" />
        </div>
        <div class="card-body px-4 py-2">
          <h2 class="text-xl font-light">Desafio {{ challenge.number }}</h2>
          <span
            v-for="(discipline, index) in disciplines"
            :key="index"
            class="my-1 text-xs text-gray-500"
          >
            {{ discipline.shortname }},
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LastChallengeCard",
  props: { challenge: Object, isLastChallenge: Boolean },
  data() {
    return {
      sideCardIconUrl: "",
      sideCardBackgroundColor: "#cbd5e0"
    };
  },
  computed: {
    disciplines: function() {
      if (this.challenge.lessons) {
        return this.challenge.lessons.map(lesson => {
          return lesson.discipline;
        });
      }
      return null;
    }
  },
  created() {
    if (this.challenge.started_at) {
      this.sideCardBackgroundColor = "#DDC982";
      this.sideCardIconUrl = "/img/icons/clock.svg";
    }

    if (this.challenge.completed_at) {
      this.sideCardBackgroundColor = "#99C884";
      this.sideCardIconUrl = "/img/icons/tick.svg";
    }
  }
};
</script>

<style lang="scss" scoped>
.card-side {
  flex: 1;
}

.card-body {
  flex: 9;
}

.challenge-card {
  border-bottom: 3px solid lightgray;
}
</style>
